// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"bb22b33b","344":"87497f0c"}[chunkId] + ".chunk.js";
};